import React, { useState } from 'react';
import { Typography } from "@material-ui/core";
import useWizardFormCtx from '../../ctx-provider/useWizardFormCtx';
import SelectField from '../../../../cmp/input/SelectField';
import SelectMenuItem from '../../../../cmp/input/SelectMenuItem';
import FormBo from '../FormBo';
import GtmFormularfeldId from '../../../../../gtm/types/GtmFormularfeldId';

export const exportAnzahlHunde = (bo: FormBo) => bo.anzahlHunde;

const AnzahlHunde = () => {
    // *** Formulardaten werden geladen    
    const { wizardFormBo, fireWizardFormBo } = useWizardFormCtx();
    const [anzahlHunde, setAnzahlHunde] = useState(wizardFormBo.ihrTier.anzahlHunde);

    // Formulardaten werden aktualisiert
    const handleOnChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        const value = event.target.value;
        const valueNumber = value as number;
        setAnzahlHunde(valueNumber);

        wizardFormBo.ihrTier.anzahlHunde = valueNumber;
        fireWizardFormBo(wizardFormBo);
    }

    return <div style={{ textAlign: 'center' }}>
        <Typography variant='body1' color='textPrimary' display='inline' style={{ marginRight: 10 }}>Ich habe</Typography>
        <div style={{ display: 'inline-block', width: 60 }}>
            <SelectField
                id='AnzahlHunde'
                idGtm={GtmFormularfeldId.hundeAnzahl}
                value={anzahlHunde}
                fullWidth={true}
                onChange={handleOnChange}>
                <SelectMenuItem value={1}>1</SelectMenuItem>
                <SelectMenuItem value={2}>2</SelectMenuItem>
                <SelectMenuItem value={3}>3</SelectMenuItem>
                <SelectMenuItem value={4}>4</SelectMenuItem>
                <SelectMenuItem value={5}>5</SelectMenuItem>
                <SelectMenuItem value={6}>6</SelectMenuItem>
            </SelectField>
        </div>

        <Typography variant='body1' color='textPrimary' display='inline' style={{ marginLeft: 10 }}>{anzahlHunde === 1 ? 'Hund' : 'Hunde'}</Typography>
    </div >
}

export default AnzahlHunde;